import { useState } from 'preact/hooks';
import { signIn } from '@/lib/supabase';
import { Icon } from '@/components/Icon';

/** Friendly access screen for the rare signed-out state. One field, saved to
 *  iCloud Keychain via the password manager; she should see this once, ever. */
export function SignInScreen() {
  const [email, setEmail] = useState(import.meta.env.VITE_DEV_EMAIL ?? '');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: Event) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const err = await signIn(email.trim(), code);
    setBusy(false);
    if (err) setError("That didn't match — double-check your access code.");
  };

  return (
    <div class="screen screen--no-tabbar" style={{ justifyContent: 'center' }}>
      <form
        onSubmit={submit}
        style={{ padding: 'var(--s-6)', display: 'flex', flexDirection: 'column', gap: 'var(--s-4)', maxWidth: '340px', width: '100%', margin: '0 auto' }}
      >
        <div style={{ textAlign: 'center', marginBottom: 'var(--s-3)' }}>
          <div
            class="avatar avatar--lg"
            style={{ margin: '0 auto var(--s-4)', background: 'var(--brand-primary)' }}
          >
            <Icon name="paw" size={26} />
          </div>
          <h1 class="t-h1" style={{ margin: 0 }}>Tend</h1>
          <p class="t-small" style={{ marginTop: 'var(--s-2)' }}>
            Stark Parks wildlife feeding tracker
          </p>
        </div>

        <div>
          <label class="label" for="signin-email">Email</label>
          <input
            id="signin-email"
            class="input"
            type="email"
            name="email"
            autocomplete="username"
            value={email}
            onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            required
          />
        </div>
        <div>
          <label class="label" for="signin-code">Access code</label>
          <input
            id="signin-code"
            class="input"
            type="password"
            name="password"
            autocomplete="current-password"
            value={code}
            onInput={(e) => setCode((e.target as HTMLInputElement).value)}
            required
          />
        </div>

        {error && (
          <p class="t-small" style={{ color: 'var(--brand-alert)', margin: 0 }} role="alert">
            {error}
          </p>
        )}

        <button class="btn btn--lg btn--block" type="submit" disabled={busy}>
          {busy ? 'Opening…' : 'Open Tend'}
        </button>
      </form>
    </div>
  );
}
